module.exports = __webpack_public_path__ + "img/hys-9.13a02add.webp";